import { request } from "./client";

export type CouponType = "NEW_USER" | "REFERRAL_WELCOME" | "STOCK_THRESHOLD" | "LARGE_PURCHASE";
export type CouponStatus = "ACTIVE" | "INACTIVE";

export interface CouponTemplate {
  id: string;
  name: string;
  type: CouponType;
  thresholdAmount: number;
  discountAmount: number;
  scopeType: "STOCK";
  totalQuantity: number;
  issuedQuantity: number;
  remainingQuantity: number;
  perUserLimit: number;
  startsAt: string;
  expiresAt: string | null;
  validDays: number | null;
  status: CouponStatus;
  sortOrder: number;
}

export interface CouponUsage {
  id: string;
  orderId: string;
  userCouponId: string;
  templateId: string;
  name: string;
  type: CouponType;
  discountAmount: number;
  createdAt: string;
}

export const listCoupons = async (status?: CouponStatus) => (await request<CouponTemplate[]>(`/admin/coupons${status ? `?status=${status}` : ""}`)).data;
export const createCoupon = async (input: unknown) => (await request<CouponTemplate>("/admin/coupons", { method: "POST", body: JSON.stringify(input) })).data;
export const updateCoupon = async (id: string, input: unknown) => (await request<CouponTemplate>(`/admin/coupons/${id}`, { method: "PATCH", body: JSON.stringify(input) })).data;
export const setCouponStatus = async (id: string, status: CouponStatus) => (await request<CouponTemplate>(`/admin/coupons/${id}/${status === "ACTIVE" ? "activate" : "deactivate"}`, { method: "POST", body: "{}" })).data;
export const listCouponUsages = async () => (await request<CouponUsage[]>("/admin/coupons/usages")).data;
